import moment from 'moment'
let phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()

export default {
  getProviderData (VueApp, provId, callback) {
    let self = this
    VueApp.$sdk.get('/provider/' + provId, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (!res.error) {
        let vehicle = res.vehicle
        let documents = res.documents
        let eligibility = res.eligibility

        let language = 'English'
        if (res.language !== null) {
          language = res.language.charAt(0).toUpperCase() + res.language.slice(1)
        }

        let vehicleInspectionExp = ''
        let driverRecordExp = ''
        if (documents.safetyInspection.expire !== null && documents.safetyInspection.expire !== '') {
          // vehicleInspectionExp = moment(documents.safetyInspection.expire, 'YYYY-MM-DD').format('MM/DD/YYYY')
          vehicleInspectionExp = self.fixDate(documents.safetyInspection.expire)
        }
        if (documents.drivingRecord.expire !== null && documents.drivingRecord.expire !== '') {
          // driverRecordExp = moment(documents.drivingRecord.expire, 'YYYY-MM-DD').format('MM/DD/YYYY')
          driverRecordExp = self.fixDate(documents.drivingRecord.expire)
        }

        VueApp.$store.commit('provider/setQuickResData', {enable: res.enabledQuickRes})
        VueApp.$store.commit('provider/setDriverId', res.driverNum || '')
        let ptrsDriverAgreeUTC = ''
        if (res.ptrsDriverAgreeUTC) ptrsDriverAgreeUTC = moment(res.ptrsDriverAgreeUTC, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
        VueApp.$store.commit('provider/setUserInfo', {
          id: res.ID,
          active: res.login.enabled && res.login.verified,
          services: res.services,
          backgroundSubmitted: !!res.bgCheckSubmitted,
          backgroundPassed: !!res.bgCheckPassed,
          maxDailyRsvpIsCustom: res.maxDailyRSVP > 0 ? '1' : '0',
          maxDailyRsvp: res.maxDailyRSVP,
          created: moment(res.created, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          ptrsDriverAgreeUTC: ptrsDriverAgreeUTC,
          isTestAcct: res.isTestAcct ? true : false,
          basicInfo: {
            firstName: res.firstName,
            lastName: res.lastName,
            deviceOS: res.phoneOS,
            deviceModel: res.phoneModel,
            language: language,
            email: res.email,
            mobile: res.countryCode + '' + res.phone,
            countryCode: res.countryCode,
            phoneNumber: res.phone,
            // birthday: moment(res.dateOfBirth, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            birthday: self.fixDate(res.dateOfBirth),
            img: res.avatarUrl || '',
            homeSectorId: res.homeSectorId
          },
          vehicleInfo: {
            manufacturer: vehicle.manufacturer,
            model: vehicle.model,
            year: vehicle.manufactureYear,
            type: vehicle.type,
            licensePlate: vehicle.licensePlate,
            capacity: vehicle.seatCapacity,
            door: vehicle.numberOfDoor,
            boxCapacity: vehicle.boxCapacity || '',
            identificationNumber: vehicle.idNumber,
            wheelchair: vehicle.wheelChairLift,
            serviceDog: vehicle.serviceDock,
            img: vehicle.photo || ''
          },
          accountType: {
            // tcpPermit: 0, // ..
            type: res.providerAccountType
          },
          businessInfo: {
            name: res.businessName,
            type: res.businessType,
            ssn: res.businessSSN ? `****${res.businessSSN.substr(res.businessSSN.length - 4)}` : '',
            ssnImg: res.businessSSNUrl || '',
            ein: res.businessEIN ? `****${res.businessEIN.substr(res.businessEIN.length - 4)}` : '',
            einImg:  res.businessEINUrl || '',
            address1: res.address,
            address2: res.address2,
            city: res.city,
            country: res.country || 'United States',
            state: res.state,
            zip: res.zip,
            w9fileImg: res.w9fileUrl || ''
          },
          documentation: {
            insuranceCompany: documents.insurance.company,
            insurancePolicy: documents.insurance.policyNumber,
            // insuranceExp: moment(documents.insurance.policyExpire, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            insuranceExp: self.fixDate(documents.insurance.policyExpire),
            insuranceImg: documents.insurance.policyFilename || '',
            cityLicense: documents.cityLicense.number,
            // cityLicenseExp: moment(documents.cityLicense.expire, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            cityLicenseExp: self.fixDate(documents.cityLicense.expire),
            cityLicenseImg: documents.cityLicense.filename || '',
            tcpPermit: documents.tcpPermit.number,
            // tcpPermitExp: moment(documents.tcpPermit.expire, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            tcpPermitExp: self.fixDate(documents.tcpPermit.expire),
            tcpPermitImg: documents.tcpPermit.filename || '',
            airportPermit: documents.airportPermit.number,
            // airportPermitExp: moment(documents.airportPermit.expire, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            airportPermitExp: self.fixDate(documents.airportPermit.expire),
            airportPermitImg: documents.airportPermit.filename || '',
            driversLicense: documents.driverLicense.number,
            // driversLicenseExp: moment(documents.driverLicense.expire, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            driversLicenseExp: self.fixDate(documents.driverLicense.expire),
            driversLicenseImg: documents.driverLicense.filename || '',
            vehicleInspection: documents.safetyInspection.by,
            vehicleInspectionExp: vehicleInspectionExp,
            vehicleInspectionImg: documents.safetyInspection.filename || '',
            drivingRecordExp: driverRecordExp,
            drivingRecordImg: documents.drivingRecord.filename || '',
            vehicleRegistrationExp: self.fixDate(documents.vehicleRegistration.expire),
            vehicleRegistrationImg: documents.vehicleRegistration.filename || ''
          },
          eligibility: {
            convicted: eligibility.CrimeProblems,
            conviction: eligibility.DrivingProblems,
            ownVehicle: eligibility.OwnVehicle,
            modifiedVehicle: eligibility.ModifiedVehicle,
            driversLicense: eligibility.Tcp
          },
          signature: res.signature,
          homeAdress: res.homeAddress
        })
      }
      callback(res)
    })
  },
  fixDate (x) {
    if (x === '' || x === '0000-00-00 00:00:00' || x === '1970-01-01T00:00:00.000Z') {
      return ''
    }
    return moment(x, 'YYYY-MM-DD').format('MM/DD/YYYY')
  },
  updateProvider (VueApp, data, callback) {
    let self = this
    // let mobile = phoneUtil.parse('+' + data.mobile, '')
    data.token = VueApp.$store.state.session.sessionToken
    let countryCode = VueApp.$store.state.countryCode.callingCode

    VueApp.$sdk.post('/provider/' + data.id + '/services', {
      token: VueApp.$store.state.session.sessionToken,
      serviceNames: data.services
    }, res => {
      // do something in case of error
    })

    VueApp.$sdk.post('/provider/' + data.id, data, res => {
      if (!res.error) {
        let phoneData = {
          id: data.id,
          // mobile: mobile.getNationalNumber(),
          // countryCode: mobile.getCountryCode(),
          mobile: data.phoneNumber,
          countryCode: countryCode,
          deviceOS: data.OS,
          deviceModel: data.model
        }
        self.updatePhone(VueApp, phoneData, function (res2) {
          callback(res2)
        })
      } else {
        callback(res)
      }
    })
  },
  updatePhone (VueApp, data, callback) {
    VueApp.$sdk.post('/provider/' + data.id + '/phones', {
      token: VueApp.$store.state.session.sessionToken,
      phoneNumber: data.mobile,
      countryCode: data.countryCode,
      'OS': data.deviceOS,
      model: data.deviceModel,
      type: 'C',
      nationalNumber: data.mobile
    }, res => {
      callback(res)
    })
  },
  emailPassword (VueApp, provId, callback) {
    VueApp.$sdk.delete('/provider/' + provId + '/password', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  updateProviderStatus (VueApp, data, callback) {
    let action = data.isActive ? 'post' : 'delete'
    VueApp.$sdk[action]('/provider/' + data.id + '/active', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  updatePassword (VueApp, data, callback) {
    VueApp.$sdk.post('/provider/' + data.id + '/password', {
      token: VueApp.$store.state.session.sessionToken,
      password: data.password
    }, res => {
      callback(res)
    })
  },
  updateProviderServices (VueApp, data, callback) {
    VueApp.$sdk.post('/provider/' + data.id + '/services', {
      token: VueApp.$store.state.session.sessionToken,
      services: data.services
    }, res => {
      callback(res)
    }, '2.0')
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/provider/user-info.js